import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ButtonMain from "../../../common/ButtonMain";
import MultipleEmail from "../../MutliEmailSelect";
import SelectInputTeam from "../../TeamSelectInput";
import AddGroupInput from "../../GroupInput";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { InviteUserApi } from "../../../../store/features/inviteUser";
import { CoUserInviteLink } from "../../../../store/features/CoUserInviteLink";
import "../../../../pages/DashboardPages/TeamManagment/style.css";

const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());

const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function AgentLegacyInviteModal({ open, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [multiEmail, setMultiEmail] = useState([]);
  const [pendingEmail, setPendingEmail] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [userName, setUserName] = useState("");
  const [buttonDisable, setButtonDisable] = useState(true);
  const [emailError, setEmailError] = useState("");
  const [isInviteLoading, setIsInviteLoading] = useState(false);
  const [isThrottled, setIsThrottled] = useState(false);

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);

  useEffect(() => {
    if (!open) {
      setMultiEmail([]);
      setPendingEmail("");
      setSelectedGroups([]);
      setUserName("");
      setEmailError("");
      setButtonDisable(true);
      setIsInviteLoading(false);
    }
  }, [open]);

  const handleEmailChange = (_event, value) => {
    setMultiEmail(value);
  };

  const handleValueStore = useCallback((emails, currentInput = "") => {
    setPendingEmail(currentInput);
    setMultiEmail(emails);
  }, []);

  useEffect(() => {
    const hasEmails = multiEmail && multiEmail.length > 0;
    const hasValidInput = pendingEmail && validateEmail(pendingEmail.trim());
    const hasRole = userName && userName.trim() !== "";
    setButtonDisable(!((hasEmails || hasValidInput) && hasRole));
  }, [userName, multiEmail, pendingEmail]);

  const closeModal = () => {
    onClose?.();
  };

  const UserInviteLink = async () => {
    if (isThrottled) return;
    setIsThrottled(true);

    try {
      const result = await dispatch(CoUserInviteLink());
      if (result?.payload?.status === 200) {
        await navigator.clipboard.writeText(result.payload.invitationLink);
        toast.success("Invitation link copied to clipboard");
      } else {
        toast.error(result?.payload?.message || "Some Error Occured. Please try again later.", toastConfig);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred", toastConfig);
    } finally {
      setTimeout(() => setIsThrottled(false), 3000);
    }
  };

  const InviteCoUser = async () => {
    setIsInviteLoading(true);
    let emailList = [];
    if (Array.isArray(multiEmail)) {
      emailList = multiEmail.map((item) => item.email);
    }

    if (pendingEmail && validateEmail(pendingEmail.trim())) {
      const pending = pendingEmail.trim();
      if (!emailList.includes(pending)) {
        emailList.push(pending);
      }
    }

    const roleId =
      userName === "admin_with_billing"
        ? "admin_with_billing"
        : userName === "agent"
          ? "agent"
          : userName === "admin"
            ? "admin"
            : userName === "supervisor"
              ? "supervisor"
              : null;

    try {
      const data = await dispatch(
        InviteUserApi({
          requestHeaders: {
            email: emailList,
            role_name: roleId,
            agent_group_id: selectedGroups,
            timezone: userTimeZone,
          },
        })
      );

      if (typeof data.payload === "undefined") {
        toast.error("Some Error Occurred. Please try again later.", toastConfig);
        setIsInviteLoading(false);
      } else if (data?.payload?.status === 200) {
        const invitations = data?.payload?.invitations || [];
        invitations.forEach((invitation) => {
          if (invitation.status === 400) {
            toast.error(`${invitation.message}`, toastConfig);
            setIsInviteLoading(false);
          } else {
            toast.success(data?.payload?.message, toastConfig);
            closeModal();
            onSuccess?.();
            setIsInviteLoading(false);
          }
        });
      } else if (data?.payload?.status === 400) {
        toast.error("some error occured");
        setIsInviteLoading(false);
      } else if (data?.payload?.status === 401) {
        toast.error("Login Expired. Please login and try again.", toastConfig);
        setIsInviteLoading(false);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred.", toastConfig);
      setIsInviteLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div>
      <div className="overlay"  style={{zIndex: 1000}}/>
      <div  className="Team-PopUp-Container">
        <div className="Team-PopUp-Header">
          <p className="PopUp-Text01">{t.ADDMEMEBER}</p>
          <p className="PopUp-Text02" onClick={closeModal}>
            <Close />
          </p>
        </div>

        <div className="PopUp-Email-Container">
          <p style={{ marginBottom: "5px" }}>{t.TITLE_EMAIL}</p>
          <MultipleEmail
            name="emailInput"
            value={multiEmail}
            onChange={handleEmailChange}
            sendValueStore={handleValueStore}
            id="tags-outlined"
          />
          {emailError ? <p style={{ color: "red" }}>{emailError}</p> : null}
          <br />
          <p>{t.ASSIGNROLE}</p>
          <SelectInputTeam value={userName} onChange={(e) => setUserName(e)} />
          <br />
          <p>Add Groups</p>
          <AddGroupInput selectedGroups={selectedGroups} setSelectedGroups={setSelectedGroups} />
          <br />
          <ButtonMain
            title="Copy invite link"
            className="buttonStyleTeam"
            onClick={UserInviteLink}
            disabled={isThrottled}
          />
          <ButtonMain
            title="Send Invite"
            className={buttonDisable || isInviteLoading ? "buttonStyleDisable-team" : "buttonStyleEnable-team"}
            onClick={InviteCoUser}
            disabled={buttonDisable || isInviteLoading}
          />
        </div>
      </div>
    </div>
  );
}
